import { Injectable } from '@angular/core';
import { OauthAEMConfig, UserDataService } from '@com-delta-idp/mnx-oauth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PingOauthService {
  authConfigJson!: Observable<OauthAEMConfig>;

  constructor(private userData: UserDataService) {}

  getAuthConfigContent(): Observable<OauthAEMConfig> {
    if (this.authConfigJson) {
      return this.authConfigJson;
    } else {
      this.authConfigJson = this.userData.getAuthConfigContent();
      return this.authConfigJson;
    }
  }
}
